import { render } from "./Mp3Player.vue?vue&type=template&id=3459b8ee&ts=true"
import script from "./Mp3Player.vue?vue&type=script&lang=ts"
export * from "./Mp3Player.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Projects\\vdmar\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__